import {
  NestjsGetListPageRequest,
  NestjsPostRequest,
} from 'nestjs-model-utility';
import { AverageEngagementClvFilterApiRoute } from 'src/domains/charts/app/api-route/information/average-engagement-clv.api';
import { InformationAbsorbtionChart } from 'src/domains/charts/app/api-route/information/information-absorption-chart';
import { AgeMonetaryChartApiRoute } from 'src/domains/charts/app/api-route/information/information-age-monetary-chart.api';
import { AgeNumberChartApiRoute } from 'src/domains/charts/app/api-route/information/information-age-number-chart.api';
import { ChartComulativeProvinceApiRoute } from 'src/domains/charts/app/api-route/information/information-chart-comulative-province.api';
import { ChartGenderApiRoute } from 'src/domains/charts/app/api-route/information/information-chart-gender.api';
import { ChartGeographicAnalysisApiRoute } from 'src/domains/charts/app/api-route/information/information-chart-geographic-analysis.api';
import { ChartGeographicDetailApiRoute } from 'src/domains/charts/app/api-route/information/information-chart-geographic-detail.api';
import { ChartMonetaryProvinceApiRoute } from 'src/domains/charts/app/api-route/information/information-chart-monetary-province.api';
import { ChartMonetaryGenderApiRoute } from 'src/domains/charts/app/api-route/information/information-chart-montary-gender.api';
import { ChartNumberMonetaryApiRoute } from 'src/domains/charts/app/api-route/information/information-chart-number-monetary.api';
import { ChartNumberProvinceApiRoute } from 'src/domains/charts/app/api-route/information/information-chart-number-province.api';
import { ChartProvinceApiRoute } from 'src/domains/charts/app/api-route/information/information-chart-province.api';
import { ChartTreemapSegmentApiRoute } from 'src/domains/charts/app/api-route/information/information-chart-treemap-segment.api';
import { ChartTreemapSubsegmentApiRoute } from 'src/domains/charts/app/api-route/information/information-chart-treemap-subsegment.api';
import { InformationDateApiRoute } from 'src/domains/charts/app/api-route/information/information-date.api';
import { GenderAgeChartApiRoute } from 'src/domains/charts/app/api-route/information/information-gender-age-chart.api';
import { JobMonetaryChartApiRoute } from 'src/domains/charts/app/api-route/information/information-job-monetary-chart.api';
import { JobNumberChartApiRoute } from 'src/domains/charts/app/api-route/information/information-job-number-chart.api';
import { RatioMonetaryChartApiRoute } from 'src/domains/charts/app/api-route/information/information-ratio-monetary-chart.api';
import { RatioSegmentChartApiRoute } from 'src/domains/charts/app/api-route/information/information-ratio-segment-chart.api';
import { RatioValueChartApiRoute } from 'src/domains/charts/app/api-route/information/information-ratio-value-chart.api';
import { ChartRetentionStatsApiRoute } from 'src/domains/charts/app/api-route/information/information-retention-stats.api';
import { SegmentMonetaryApiRoute } from 'src/domains/charts/app/api-route/information/information-segment-monetary.api';
import { SegmentNumberApiRoute } from 'src/domains/charts/app/api-route/information/information-segment-number.api';
import { SubsegmentMonetaryApiRoute } from 'src/domains/charts/app/api-route/information/information-subsegment-monetary.api';
import { SubsegmentNumberApiRoute } from 'src/domains/charts/app/api-route/information/information-subsegment-number.api';
import { TransactionTypeChartApiRoute } from 'src/domains/charts/app/api-route/information/information-transaction-type-chart.api';
import { GeoAnlaysisModel } from '../geo-analysis/geo-analysis-model';
import { InformationModel } from './information.model';
import { CountMonetaryProfileTypeApiRoute } from '../../app/api-route/information/information-count-monetary-profile-type.api';
import { ChartBalanceApiRoute } from '../../app/api-route/information/information-chart-balance.api';
export namespace InformationRequest {
  export class ChartsDate extends NestjsPostRequest<InformationModel.chartsDate,
    InformationModel.chartsDate
  > {
    _api = InformationDateApiRoute;
    cache: true = true;
  }
  export class AddChartNumberMonetary extends NestjsPostRequest<InformationModel.NumberMonetary,
    InformationModel.NumberMonetary
  > {
    _api = ChartNumberMonetaryApiRoute;
    cache: true = true;
  }
  export class AddChartTreemapSegment extends NestjsPostRequest<InformationModel.treemapSegment,
    InformationModel.treemapSegment
  > {
    _api = ChartTreemapSegmentApiRoute;
    cache: true = true;
  }
  export class AddChartTreemapSubsegment extends NestjsPostRequest<InformationModel.treemapSubsegment,
    InformationModel.treemapSubsegment
  > {
    _api = ChartTreemapSubsegmentApiRoute;
    cache: true = true;
  }
  export class AddChartComulativeProvince extends NestjsPostRequest<InformationModel.chartComulativeProvince,
    InformationModel.chartComulativeProvince
  > {
    _api = ChartComulativeProvinceApiRoute;
    cache: true = true;
  }
  export class AddGeographicDetail extends NestjsPostRequest<GeoAnlaysisModel.Index,
    InformationModel.chartGeographicDetail
  > {
    _api = ChartGeographicDetailApiRoute;
    cache: true = true;
  }
  export class AddGeographicAnalysis extends NestjsPostRequest<InformationModel.chartGeographicAnalysis,
    InformationModel.chartGeographicAnalysis
  > {
    _api = ChartGeographicAnalysisApiRoute;
    cache: true = true;
  }
  export class AddChartMonetaryProvince extends NestjsPostRequest<InformationModel.chartMonetaryProvince,
    InformationModel.chartMonetaryProvince
  > {
    _api = ChartMonetaryProvinceApiRoute;
    cache: true = true;
  }
  export class AddChartNumberProvince extends NestjsPostRequest<InformationModel.chartNumberProvince,
    InformationModel.chartNumberProvince
  > {
    _api = ChartNumberProvinceApiRoute;
    cache: true = true;
  }
  export class AddRatioValueChart extends NestjsPostRequest<InformationModel.ratioValueChart,
    InformationModel.ratioValueChart
  > {
    _api = RatioValueChartApiRoute;
    cache: true = true;
  }
  export class AddRatioMonetaryChart extends NestjsPostRequest<InformationModel.RatioResponse,
    InformationModel.ratioMonetaryChart
  > {
    _api = RatioMonetaryChartApiRoute;
    cache: true = true;
  }
  export class AddRatioSegmentChart extends NestjsPostRequest<InformationModel.RatioResponse,
    InformationModel.ratioSegmetnChart
  > {
    _api = RatioSegmentChartApiRoute;
    cache: true = true;
  }
  export class AddGenderChart extends NestjsPostRequest<InformationModel.response,
    InformationModel.ChartGender
  > {
    _api = ChartGenderApiRoute;
    cache: true = true;
  }
  export class AddGenderAgeChart extends NestjsPostRequest<InformationModel.response,
    InformationModel.ChartGenderAge
  > {
    _api = GenderAgeChartApiRoute;
    cache: true = true;
  }
  export class AddGenderMonetary extends NestjsPostRequest<InformationModel.ChartMonetaryGender,
    InformationModel.ChartMonetaryGender
  > {
    _api = ChartMonetaryGenderApiRoute;
    cache: true = true;
  }
  export class AddChartProvince extends NestjsPostRequest<InformationModel.ChartProvince,
    InformationModel.ChartProvince
  > {
    _api = ChartProvinceApiRoute;
    cache: true = true;
  }
  export class AddJobNumberChart extends NestjsPostRequest<InformationModel.ChartJobNumber,
    InformationModel.ChartJobNumber
  > {
    _api = JobNumberChartApiRoute;
    cache: true = true;
  }
  export class AddJobMonetaryChart extends NestjsPostRequest<InformationModel.ChartJobMonetary,
    InformationModel.ChartJobMonetary
  > {
    _api = JobMonetaryChartApiRoute;
    cache: true = true;
  }
  export class AddAgeNumberChart extends NestjsPostRequest<InformationModel.ChartAgeNumber,
    InformationModel.ChartAgeNumber
  > {
    _api = AgeNumberChartApiRoute;
    cache: true = true;
  }
  export class AddAgeMonetaryChart extends NestjsPostRequest<InformationModel.ChartAgeMonetary,
    InformationModel.ChartAgeMonetary
  > {
    _api = AgeMonetaryChartApiRoute;
    cache: true = true;
  }
  export class AddTransactionTypeChart extends NestjsPostRequest<InformationModel.TransactionTypeChart,
    InformationModel.TransactionTypeChart
  > {
    _api = TransactionTypeChartApiRoute;
    cache: true = true;
  }
  export class ListSegmentNumber extends NestjsPostRequest<InformationModel.NumberMonetaryResponse,
    InformationModel.segmentNumberMonetary
  > {
    _api = SegmentNumberApiRoute;
    cache: true = true;
  }
  export class ListSubSegmentNumber extends NestjsPostRequest<InformationModel.NumberMonetaryResponse,
    InformationModel.segmentNumberMonetary
  > {
    _api = SubsegmentNumberApiRoute;
    cache: true = true;
  }
  export class ListSegmentMonetary extends NestjsPostRequest<InformationModel.NumberMonetaryResponse,
    InformationModel.segmentNumberMonetary
  > {
    _api = SegmentMonetaryApiRoute;
    cache: true = true;
  }
  export class ListSubSegmentMonetary extends NestjsPostRequest<InformationModel.NumberMonetaryResponse,
    InformationModel.segmentNumberMonetary
  > {
    _api = SubsegmentMonetaryApiRoute;
    cache: true = true;
  }
  export class AddAbsorbtionChart extends NestjsPostRequest<InformationModel.RatioResponse,
    InformationModel.absorbtionChart
  > {
    _api = InformationAbsorbtionChart;
    cache: true = true;
  }
  export class AddQuestions extends NestjsPostRequest<InformationModel.RatioResponse,
    InformationModel.absorbtionChart
  > {
    _api = InformationAbsorbtionChart;
    cache: true = true;
  }
  export class AddRetentionStats extends NestjsPostRequest<InformationModel.RetentionalResponse,
    InformationModel.retentionStats
  > {
    _api = ChartRetentionStatsApiRoute;
    cache: true = true;
  }
  export class AddCountMonetaryProfileType extends NestjsPostRequest<InformationModel.RetentionalResponse,
    InformationModel.retentionStats
  > {
    _api = CountMonetaryProfileTypeApiRoute;
    cache: true = true;
  }
  export class ListAverageEngagementClv extends NestjsGetListPageRequest<InformationModel.averageEngagement,
    true,
    typeof AverageEngagementClvFilterApiRoute
  > {
    _api = AverageEngagementClvFilterApiRoute;
    cache: true = true;
  }
  export class AddChartBalance extends NestjsPostRequest<InformationModel.ChartBanlace,
    InformationModel.ChartBanlace
  > {
    _api = ChartBalanceApiRoute;
    cache: true = true;
  }
}
